<template>
  <gg-modal :is-active="isActive" @close="closeDialog">
    <template v-slot:toolbar>{{ title }}</template>
    <template v-slot:body>
      <v-row>
        <v-col v-if="!isModeDelete" cols="12" class="body-1 pb-4">
          {{ hint }}
        </v-col>
        <v-col cols="12" :sm="gridSize" class="py-0">
          <gg-select
            v-model="record_local.type"
            outlined
            dense
            label="Type"
            :disabled="loading || isModeDelete"
            :items="allowed_types"
            v-validate="'required'"
            name="type"
            data-vv-as="Record type"
            :error-messages="errors.collect('type')"
            @change="recordChanged"
          />
        </v-col>
        <v-col cols="12" :sm="gridSize" class="py-0">
          <gg-text-field
            v-model="record_local.name"
            outlined
            dense
            label="Name"
            :disabled="loading || isModeDelete"
            name="name"
            v-validate="'required'"
            data-vv-as="Name"
            :error-messages="errors.collect('name')"
            @input="recordChanged"
          />
        </v-col>
        <v-col cols="12" :sm="gridSize" class="py-0">
          <gg-text-field
            v-model="record_local.address"
            label="Address"
            :disabled="loading || isModeDelete"
            outlined
            dense
            name="address"
            data-vv-as="Address"
            v-validate="addressValidation"
            :error-messages="errors.collect('address')"
            @input="recordChanged"
          />
        </v-col>
        <v-col v-if="record.type === 'MX'" cols="12" :sm="gridSize" class="py-0">
          <gg-text-field
            v-model="record_local.mxpref"
            label="Priority"
            :disabled="loading || isModeDelete"
            outlined
            dense
            name="mxpref"
            data-vv-as="Priority"
            v-validate="'between:0,1000'"
            :error-messages="errors.collect('mxpref')"
            @input="recordChanged"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="closeDialog">
        Cancel
      </gg-btn>
      <gg-btn primary :loading="loading" @click.prevent="submitFunction">
        {{ submitBtnText }}
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { deepCopy, validateIP6 } from 'Helpers/helpers'
import { Validator } from 'vee-validate'

const ipv6validator = {
  getMessage (field, args) {
    return `The ${field} must be a valid IPv6 address.`
  },
  validate (value, args) {
    return validateIP6(value)
  }
}

export default {
  name: 'RecordsEdit',
  inject: ['parentValidator'],
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    editMode: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    allowed_types: {
      type: Array,
      required: true
    },
    record: {
      type: Object,
      required: true
    },
    submitFunction: {
      type: Function,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    hint: {
      type: String,
    }
  },
  data: () => ({
    record_local: {},
  }),
  created () {
    this.$validator = this.parentValidator
    Validator.extend('ipv6validator', ipv6validator)

    this.record_local = deepCopy(this.record)
  },
  computed: {
    submitBtnText () {
      return this.editMode === 'delete' ? 'Delete' : 'Save'
    },
    isModeDelete () {
      return this.editMode === 'delete'
    },
    addressValidation () {
      const rules = ['required']

      switch (this.record.type) {
        case 'A':
          rules.push('ip')
          break
        case 'AAAA':
          rules.push('ipv6validator')
          break
      }

      return rules.join('|')
    },
    gridSize () {
      return this.record.type === 'MX' ? '6' : '4'
    }
  },
  methods: {
    recordChanged () {
      this.$emit('changed', this.record_local)
    },
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>
